export default class footer {
  init() {
    this.scrollFade();
    this.btnFixed();
  }
  scrollFade(){
    var winHeight = $(window).height(),
        topBtn = $('.l-footer_scroll');

    $(window).on('scroll', function() {
      var winTop = $(window).scrollTop(),
          docHeight = $(document).height(),
          footerTop = $('footer').offset().top;
      if(winTop > 300){
        topBtn.fadeIn(200);
      }else{
        topBtn.fadeOut(200);
      }
    });
  }

  btnFixed(){
    var winHeight = $(window).height(),
        topBtn = $('.l-footer_scroll');
    $(window).on('scroll', function() {
      var winTop = $(window).scrollTop(),
          footerTop = $('footer').offset().top;
      if(winHeight + winTop >= footerTop ){
        topBtn.addClass('is-stop');
      }else{
        topBtn.removeClass('is-stop');
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/footer.js